import { Injectable } from "@angular/core";

import { platform } from "../../platform/platform";
import { MEASUREMENT_IMAGE_TYPE, PLATFORM } from "../app.constants";

@Injectable({
  providedIn: "root"
})
export class MeasurementModeService {
  public isMerryMeasurementSupported(imageType: string): boolean {
    return platform.name === PLATFORM.DESKTOP && imageType === MEASUREMENT_IMAGE_TYPE.BRIAN_IMAGE;
  }
}
